import { defineComponent as _defineComponent } from 'vue'
import VersionCheck from '@/services/versionCheck/VersionCheck';
import UserButton from '@/modules/navigation/UserButton.vue';
import AuthService from '@/modules/user/AuthService';
import ConfigurationApi from '@/modules/configuration/services/ConfigurationApi';
import {StorageKeys} from '@/commons/enums/StorageKeys';
import {Utils} from '@/services/utils/BasicUtils';
import {TransitionParams} from '@/models/Transition';
import {getConfigBooleanValue, saveConfigValue, toggleTheme} from '@/services/theme/ThemeService';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {Route} from 'vue-router';
import {Routes} from '@/router/Routes';
import moment from 'moment';
import {computed, getCurrentInstance, onMounted, provide, ref, watch} from 'vue';
import GoToService from '@/router/GoToService';
import BaseNavigationLogo from '@/modules/navigation/BaseNavigationLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseNavigation',
  props: {
    readonly: { type: Boolean, default: false },
    minNavigation: { type: Boolean, default: false },
    hideNavigation: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { readonly: boolean, minNavigation: boolean, hideNavigation: boolean }

const MOBILE_APP_BAR_HEIGHT = '40px';
const DESKTOP_APP_BAR_HEIGHT = '56px';
const MINI_VARIANT_WIDTH = '80px';



const day = ref<string>('');
const newTime = ref<string>('2019-04-29T10:15:30.00Z');
const miniVariant = ref<boolean>(props.minNavigation);
const navbar = ref<boolean>(false);

const instance = getCurrentInstance();
/*  This ref is injected in MyCalendar.vue and DashboardActivities.vue with use useActivityRefreshFromNotification.ts
    and in NotificationBar.vue !!!!It's a workaround !!!!->
    only way to get a db's user's activities listener is to listen on notification's socket in NotificationService.ts */
const areActivitiesToBeFetched = ref<boolean>(false);
provide('areActivitiesToBeFetched', areActivitiesToBeFetched);
const isOnboardingEnabled = async() => await instance?.proxy.$onboarding.tours.DASHBOARD.isEnabled();

watch(() => instance?.proxy.$route, async(route?: Route) => {
  if (route?.name === Routes.DASHBOARD && await isOnboardingEnabled()) {
    miniVariant.value = false;
  }
});

const changeSystemClock = async() => {
  await ConfigurationApi.setSystemClock(JSON.stringify({instant: newTime.value,}));
  day.value = await ConfigurationApi.getSystemClock();
};

const resetSystemClock = async() => {
  await ConfigurationApi.resetSystemClock();
  day.value = await ConfigurationApi.getSystemClock();
};

onMounted(async() => {
  if (AuthService.User && !AuthService.User?.privileges.isHrLocked && await isOnboardingEnabled()) {
    miniVariant.value = false;
  } else {
    miniVariant.value = getConfigBooleanValue(StorageKeys.MINI_MENU);
  }
  try {
    if (instance?.proxy.$env.isPreprodOrDev) {
      day.value = await ConfigurationApi.getSystemClock();
    }
  } catch (e) {
    instance?.proxy.errorHandler(e, I18NGetter().useBaseNavigation.FAILED_TO_FETCH_DATE);
  }
});

const reload = (): void => {
  window.location.reload();
};

const isMiniMenu = computed<boolean>(
  () => instance!.proxy.$vuetify.breakpoint.smAndUp && (miniVariant.value || props.minNavigation)
);

const themeColorI18n = computed<string>(
  () => instance!.proxy.$vuetify.theme.dark
    ? I18NGetter().usePlatformSection.NEW_TRANSLATION_CHOOSE_THEME_COLOR_LIGHT
    : I18NGetter().usePlatformSection.NEW_TRANSLATION_CHOOSE_THEME_COLOR_DARK,
);

const changeMenuSizeI18n = computed<string>(
  () => isMiniMenu.value
    ? I18NGetter().usePlatformSection.NEW_TRANSLATION_MAXIMIZE
    : I18NGetter().usePlatformSection.NEW_TRANSLATION_MINIFY
);

const showVersionAlert = computed<boolean>(() => VersionCheck.ApplicationObservable.requireReload);

const logOut = () => {
  AuthService.logout();
};

const buildDate = computed<string>(() => moment(instance?.proxy.$env.buildDate).format('DD.MM.YYYY HH:mm'));

const onLogoClick = () => {
  if (!props.readonly) {
    GoToService.dashboard();
  }
};

const onThemeToggle = () => {
  const transitionParams = new TransitionParams({callback: toggleTheme, properties: ['background-color', 'color', 'opacity',],});
  Utils.makeTransition(transitionParams);
};
const onMenuToggle = () => {
  miniVariant.value = !miniVariant.value;
  saveConfigValue(StorageKeys.MINI_MENU, miniVariant.value);
};

return { __sfc: true,MOBILE_APP_BAR_HEIGHT, DESKTOP_APP_BAR_HEIGHT, MINI_VARIANT_WIDTH, props, day, newTime, miniVariant, navbar, instance, areActivitiesToBeFetched, isOnboardingEnabled, changeSystemClock, resetSystemClock, reload, isMiniMenu, themeColorI18n, changeMenuSizeI18n, showVersionAlert, logOut, buildDate, onLogoClick, onThemeToggle, onMenuToggle, UserButton, BaseNavigationLogo }
}

})